import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./calender.css";
import Modal from "components/ui/Modal";
import Popover from "@mui/material/Popover";
import { getIcon } from "utils/iconsConfig";
import Button from "components/ui/Button";
import { Typography } from "@mui/material";
import { formatDate } from "utils/formatDate";

const CalenderComp = ({ open, handleClose, onDateSelect, disableRestrictedDates = false, style, privSelectedDate, content, rangeOfDate = {}, autoSelect = false, compact = false, isPopover = false, anchorEl = null, isCreateProject = false, formatOnApply = false, allowAllDates = false }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);

  const minDate = rangeOfDate?.min?.() || null;
  const maxDate = rangeOfDate?.max?.() || null;

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (autoSelect) {
      onDateSelect(formatDate(date));
      handleClose();
    }
  };

  const handleApplyDate = () => {
    if (selectedDate) {
      onDateSelect(formatOnApply ? formatDate(selectedDate) : selectedDate);
      handleClose();
    }
  };
const handleDateSelect = (date) => {
  if (autoSelect && date) {
    setSelectedDate(date);
    onDateSelect(formatDate(date));
    handleClose();
  }
};

  const dateFilter = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (isCreateProject) {
      if (!disableRestrictedDates) {
        return date <= today;
      }
      return date >= today;
    }
    if (date.getDay() === 0) return false;
    if (!disableRestrictedDates) {
      return date <= today;
    }
    let count = 0;
    const minDate = new Date(today);
    while (count < 5) {
      minDate.setDate(minDate.getDate() + 1);
      if (minDate.getDay() !== 0) {
        count++;
      }
    }
    return date >= minDate;
  };

 useEffect(() => {
  if (open && disableRestrictedDates && !isCreateProject) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let count = 0;
    const sixthDay = new Date(today);

    while (count < 5) {
      sixthDay.setDate(sixthDay.getDate() + 1);
      if (sixthDay.getDay() !== 0) count++;
    }

    setSelectedDate((prev) => {
      if (!prev || !dateFilter(prev)) {
        return sixthDay;
      }
      return prev;
    });
  }
}, [open]);
  
  const calendarContent = (
    <div className="calendar-popup" style={isPopover ? { padding: "10px", paddingTop: "30px", position: "relative" } : {}}>
      {selectedDate && (
        <Typography
          className="reset-btn"
          style={isPopover ? { top: "5px", right: "0px", paddingRight: "10px" } : {}}
          onClick={() => {
            setSelectedDate(null);
            onDateSelect(null); // Reset to show all
            handleClose();
          }}
        >
          Reset
        </Typography>
      )}
      <DatePicker
        inline
        fixedHeight
        selected={selectedDate}
        onChange={handleDateChange}
          onSelect={handleDateSelect} 
        dateFormat="dd/MM/yyyy"
        filterDate={allowAllDates ? undefined : dateFilter}
        calendarClassName="custom-calendar"
        renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
          <div className="custom-header" style={isPopover ? { paddingRight: "0px" } : {}}>
            <div className="header-title">
              {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
            </div>

            <div className="header-buttons">
              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="prev-button">
                {getIcon("prev")}
              </button>
              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="next-button">
                {getIcon("next")}
              </button>
            </div>
          </div>
        )}
        formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 3).toUpperCase()}
      />
      <Button type="submit" variant="outlined" size="large" fullWidth className={`btns  ${selectedDate ? "btns-green" : "btn-default"}`} onClick={handleApplyDate}>
        Apply Date
      </Button>
    </div>
  );

  if (isPopover) {
    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { width: "380px" },
          sx: { mt: 1, borderRadius: "5px", overflow: "hidden", bgcolor: "#fff", color: "#000" },
        }}
      >
        {calendarContent}
      </Popover>
    );
  }

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      style={{
        width: "430px",
        mr: compact ? 65 : 60,
        height: compact ? "auto" : "455px",
        paddingBottom: compact ? "10px" : "20px",
      }}
    >
  {/* useEffect(() => {
    if (privSelectedDate) {
      setSelectedDate(privSelectedDate || null);
    }

    return () => {
      setSelectedDate(null);
    };
  }, [privSelectedDate]);

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "430px", height: "520px", mr: 60, ...style }}> */}
      <div className="calendar-popup">
        {selectedDate && (
          <Typography
            className="reset-btn"
            onClick={() => {
              setSelectedDate(null);
              onDateSelect(null); // Reset to show all
              // handleClose();
            }}
          >
            Reset
          </Typography>
        )}
        {content && content?.topTitle && <Typography className="content-toptile">{content?.topTitle}</Typography>}
        <DatePicker
          inline
          fixedHeight
          selected={selectedDate}
          onChange={handleDateChange}
            onSelect={handleDateSelect}
          dateFormat="dd/MM/yyyy"
          filterDate={allowAllDates ? undefined : dateFilter}
          calendarClassName={`custom-calendar ${compact ? "compact-calendar" : ""}`}
          renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
            <div className="custom-header">
              <div className="header-title">
                {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
              </div>

              <div className="header-buttons">
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="prev-button">
                  {getIcon("prev")}
                </button>
                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="next-button">
                  {getIcon("next")}
                </button>
              </div>
            </div>
          )}
          formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 3).toUpperCase()}
          minDate={minDate}
          maxDate={maxDate}
        />
        {!autoSelect && (
          <Button type="submit" variant="outlined" size="large" fullWidth className={`btns ${selectedDate ? "btns-green" : "btn-default"}`} onClick={handleApplyDate}>
            Apply Date
          </Button>
        )}
      </div>
      {/* {calendarContent} */}
    </Modal>
  );
};

export default CalenderComp;
